/* eslint-env browser */
const loadWorker = new Worker('scripts/worker-load.js')
let lazyElements
const requets = []
let count = 0
const lazyLoad = () => {
  requets.push(letsGo())
}

const letsGo = function () {
  const target = lazyElements ? lazyElements[count] : false
  if (target) {
    fastdom.measure(() => {

      const srcset = target.getAttribute('data-srcset')
      const cut = window.innerHeight + (300 * Math.floor((window.innerWidth / 500)))
      const top = Math.floor(target.getBoundingClientRect().top)
      if (top < cut) {
        const result = {
          srcset,
          count,
          width: window.innerWidth,
        }
        count += 1

        loadWorker.postMessage(result)
        loadWorker.onmessage = event => {
          const {
            success,
            code,
            response,
            count: countResult,
          } = event.data
          if (success) {
            fastdom.mutate(() => {
              lazyElements[countResult].setAttribute('src', window.URL.createObjectURL(response))
            })
          } else {
            console.error(code)
          }
        }
      }
    })
  }
}

const getLazyElements = listener => {
  lazyElements = document.querySelectorAll('.lazyload')
  if (listener) window.addEventListener('scroll', lazyLoad, false)
}
